import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Form from "../../../components/Form/Form";
import FormTitle from "../../../components/FormTitle/FormTitle";
import Input from "../../../components/Input/Input";
import Loader from "../../../components/Loader/Loader";
import { useListManager } from "../../../contexts/list.manager";
import "./FormWebhooks.css";
import NotificationsService from "../../../services/NotificationsService";
import DualList from "../../../components/DualList/DualList/DualList";
import { NotificationTargetType } from "../../../constants/notifications.constants";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";
import { useUserStore } from "../../../contexts/userStore";
import Select from "../../../components/Select/Select";
import { useAuth } from "../../../contexts/auth";
import { MdWebhook } from "react-icons/md";
import { WebhookCategoriesDDL } from "../../../components/WebhookCategoriesDDL/WebhookCategoriesDDL";

function FormWebhooks(props) {
	const [nome, setNome] = useState(props.webhook?.name);
	const [url, setUrl] = useState(props.webhook?.url || "");
	const [secret, setSecret] = useState(props.webhook?.secret || "");
	const [enabled, setEnabled] = useState(props.webhook?.enabled || true);
	const [unitExternalId, setUnitExternalId] = useState(props.webhook?.unitExternalId || "");

	const [showLoader, setShowLoader] = useState(false);
	const [allCategories, setAllCategories] = useState([]);
	const [selectedCategories, setSelectedCategories] = useState([]);
	const [notSelectedCategories, setNotSelectedCategories] = useState([]);

	const { user } = useAuth();
	const { condominiums, selectedCondominioObj, licences } = useUserStore();
	const { closeForm } = useListManager();

	useEffect(() => {
		setSelectedCategories(props.webhook ? props.webhook.categories?.map(category => {
			const categoryData = allCategories.find(categoryData => category.id === categoryData.categoryId);
			return {
				label: categoryData?.categoryName,
				value: categoryData?.categoryId,
				id: categoryData?.categoryId,
			};
		}) : [])
		setNotSelectedCategories(allCategories.filter(categoryData => !props.webhook || !props.webhook.categories?.find(category => category.id === categoryData.categoryId)).map(categoryData => ({
			label: categoryData.categoryName,
			value: categoryData.categoryId,
			id: categoryData.categoryId,
		})))
	}, [allCategories, props.webhook])

	useEffect(() => {
		setNome(props.webhook?.name);
		setUrl(props.webhook?.url || "");
		setSecret(props.webhook?.secret || "");
		setEnabled(props.webhook?.enabled || true);
		setUnitExternalId((props.webhook?.unitExternalId || (props.type === "cadastro" ? selectedCondominioObj.externalId : props.webhook?.unitExternalId)) ?? -1);
	}, [props.webhook]);

	useEffect(() => {
		if (props.type !== "consulta") {
			listLicences();
		}
	}, [props.type]);

	const navigate = useNavigate();

	const buildPayload = () => {
		let payload = {
			name: nome,
			url: url,
			secret: secret,
			enabled: enabled,
			unitExternalId: unitExternalId === -1 ? null : unitExternalId,
			categories: [
				...selectedCategories.map(category => category.id)
			],
		};
		return payload;
	};

	async function handleSubmit(event) {
		event.preventDefault();
		setShowLoader(true);
		const payload = buildPayload();
		let response = {};
		if (props.type === "edicao") {
			response = await NotificationsService.updateWebhook(props.webhook.id, payload);
		}
		if (props.type === "cadastro") {
			response = await NotificationsService.createWebhook(payload);
		}
		setShowLoader(false);
		if (!response.data.id) return;
		navigate("../consulta-webhooks", {
			state: { refresh: true }
		});
	}

	async function handleDelete() {
		setShowLoader(true);
		if (!props.webhook) return;
		await NotificationsService.deleteWebhook(props.webhook.id);
		navigate("../consulta-webhooks", {
			state: { deletedId: props.webhook.id },
		});
		setShowLoader(false);
		closeForm();
	}

	const handleClickEditButton = () => {
		if (!props.webhook) return;
		navigate(`/webhooks/${props.webhook.externalId}`, { state: props.webhook });
	};

	const handleDualList = (notSelected, selected) => {
		setSelectedCategories(selected);
		setNotSelectedCategories(notSelected);
	};

	async function listLicences() {
		const response = await NotificationsService.listCategoriesTargets();
		const webhookCategories = response.data.filter(item => item.targetTypeId === `${NotificationTargetType.Webhook}`);
		setAllCategories(webhookCategories);
	}

	return (
		<React.Fragment>
			<FormTitle
				type={props.type}
				icon={<MdWebhook size={19} />}
				tituloConsulta={props.webhook?.name || null}
				tituloCadastro="Cadastro de Webhook"
				backRoute={"/consulta-webhooks"}
			/>
			{showLoader ? (
				<Loader />
			) : (
				<Form
					handleSubmit={handleSubmit}
					type={props.type}
					handleClickEdit={handleClickEditButton}
					handleDelete={handleDelete}
					navigateCancelUrl="../consulta-webhooks"
					askForPasswordOnDelete={true}
				>
					<div className="grid-2">
						<Input
							name={"nome"}
							id="nome"
							labelText={"Nome *"}
							value={nome}
							onChange={({ target }) => setNome(target.value)}
							disabled={props.type === "consulta"}
							required={true}
						/>
						<Input
							name="url"
							id="url"
							labelText="URL *"
							value={url}
							onChange={({ target }) => setUrl(target.value)}
							required
							disabled={props.type === "consulta"}
						/>
					</div>
					<div className="grid-2">
						<Select
							labelText="Licença"
							name="unitExternalId"
							id="unitExternalId"
							value={unitExternalId}
							onChange={({ target }) =>
								setUnitExternalId(target.value)
							}
							required={true}
							options={[
								{
									value: -1,
									text: "Todas"
								},
								...condominiums.filter(unit => unit.organizationId === user.userData.selectedOrganizationId && !unit.isDeviceUnit && unit.parentId).map(unit => {
									const license = licences.find(license => license.id_condominium === Number(unit.id));
									return {
										value: unit.externalId,
										text: `${unit.name}${license ? ` (${license?.SN_equipment})` : ''}`,
									};
								})
							]}
						/>
						<Input
							name={"secret"}
							id="secret"
							labelText={"Token *"}
							value={secret}
							onChange={({ target }) => setSecret(target.value)}
							disabled={props.type === "consulta"}
							required={true}
						/>
						<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center' }}>
							<ToggleButton
								name={`enabled`}
								id={`enabled`}
								label={
									enabled ? "Habilitado" : "Desabilitado"
								}
								defaultChecked={enabled}
								selected={enabled}
								onChange={({ target }) =>
									setEnabled(target.checked)
								}
								required={false}
								hidden={props.type === "consulta"}
								disabled={props.type === "consulta"}
								tooltipText="Habilita ou desabilita o webhook"
								tooltipVisible={true}
							/>
						</div>
					</div>
					{/* Seção para categorias de notificações */}
					<div className="licenses-and-observations">
						{props.type !== "consulta" && (
							<div className="form-cond-dual-list-container">
								<WebhookCategoriesDDL
									categories={selectedCategories}
									onChangeList={(selected) =>
										setSelectedCategories(selected)
									}
								/>
							</div>
						)}
					</div>
				</Form>
			)
			}
		</React.Fragment >
	);
}

export default FormWebhooks;
